import {useState, useEffect} from 'react';
import {Routes, Route, Link} from 'react-router-dom'

import List from '../list/list.component';
import BreadCrumb from '../BreadCrumb/breadcrumb.component';
import './home.style.css';

import { useTranslation } from "react-i18next";
import "../../translations/i18n";


const Home = ({apiUrl}) => {

    const [laboratories, setLaboratories] = useState([]);
    const [activityCategories, setActivityCategories] = useState([]);
    const [types, setTypes] = useState([]);


    const { t } = useTranslation();

    useEffect(()=>{
        fetch(apiUrl+'Laboratories').then(response=> response.json())
       .then((laboratories) => {setLaboratories(laboratories);})
     },[apiUrl]);

    useEffect(()=>{
        fetch(apiUrl+'ActivityCategories').then(response=> response.json())
       .then((activityCategories) => {setActivityCategories(activityCategories);})
     },[apiUrl]);

    useEffect(()=>{
        fetch(apiUrl+'Types').then(response=> response.json())
       .then((types) => {setTypes(types);})
     },[apiUrl]);

    return (
        <>

            <BreadCrumb paths={
            [
                {
                    Name: t('breadcrumb.start.name'),
                    Url: t('breadcrumb.start.url')
                },
                {
                    Name: t('breadcrumb.infrastructure.name'),
                    Url: t('breadcrumb.infrastructure.url')
                  },
                {
                    Name:t('breadcrumb.catalogue.name'),
                    Url: ''
                },
            ]
            }
        />
            <div className="resources-header">
                <h1>{t('home.catalogue')}</h1>
            </div>
            <Link className="returnlink" to={`/search/`}>{t('home.see_all')}</Link>
            <Link className="returnlink" to={`/map/`}>{t('map.show_map')}</Link>
            <div>
                <h2>{t('home.laboratories')}</h2>
                <List filter='lab' array={laboratories}/>
            </div>
            <div className="spacer-bar"></div>
            <div>
                <h2>{t('home.activityCategories')}</h2>
                <List filter='actcat' array={activityCategories}/>
            </div>
            <div className="spacer-bar"></div>
            <div>
                <h2>{t('home.types')}</h2>
                <List filter='type' array={types}/>
            </div>
        </>
    )

}

export default Home;

